/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface PaymentTerms
 */
export interface PaymentTerms {
    /**
     * 
     * @type {PaymentMethod}
     * @memberof PaymentTerms
     */
    paymentMethod: PaymentMethod;
    /**
     * 
     * @type {number}
     * @memberof PaymentTerms
     */
    paymentDueDays: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentTerms
     */
    cashDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentTerms
     */
    cashDiscountDays: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentTerms
     */
    freightAllowance: number;
}



/**
 * Check if a given object implements the PaymentTerms interface.
 */
export function instanceOfPaymentTerms(value: object): value is PaymentTerms {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentDueDays' in value) || value['paymentDueDays'] === undefined) return false;
    if (!('cashDiscount' in value) || value['cashDiscount'] === undefined) return false;
    if (!('cashDiscountDays' in value) || value['cashDiscountDays'] === undefined) return false;
    if (!('freightAllowance' in value) || value['freightAllowance'] === undefined) return false;
    return true;
}

export function PaymentTermsFromJSON(json: any): PaymentTerms {
    return PaymentTermsFromJSONTyped(json, false);
}

export function PaymentTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentTerms {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'paymentDueDays': json['paymentDueDays'],
        'cashDiscount': json['cashDiscount'],
        'cashDiscountDays': json['cashDiscountDays'],
        'freightAllowance': json['freightAllowance'],
    };
}

export function PaymentTermsToJSON(json: any): PaymentTerms {
    return PaymentTermsToJSONTyped(json, false);
}

export function PaymentTermsToJSONTyped(value?: PaymentTerms | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'paymentDueDays': value['paymentDueDays'],
        'cashDiscount': value['cashDiscount'],
        'cashDiscountDays': value['cashDiscountDays'],
        'freightAllowance': value['freightAllowance'],
    };
}

